import "./App.css";
import HomeDashboard from "./component/Dashboard/UserDashboard/HomeDashboard/HomeDashboard";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useState } from "react";
import Home from "./component/Home/Home";

import CustomerREQ from "./component/Dashboard/AdminDashboard/CustomerREQ/CustomerREQ";
import Chart from "./component/Dashboard/AdminDashboard/Chart/Chart";
import REQ from "./component/Dashboard/AdminDashboard/Req/REQ";
import ReqForChange from "./component/Dashboard/UserDashboard/Service/Pages/ReqForChange";
import UserTab from "./component/Dashboard/UserDashboard/UserTab/UserTab";
import ViewQuotes from "./component/Dashboard/UserDashboard/Service/Pages/ViewQuotes";
import AdminViewQuote from "./component/Dashboard/AdminDashboard/ViewQuote/AdminViewQuote";

import UserClosed from "./component/Dashboard/UserDashboard/Service/Pages/UserClosed";
import Booking from "./component/Pages/Booking/Booking";
import Modal from "./component/Modal/Modal";
import LoginModal from "./component/Modal/LoginModal";
import SubmitAfterModal from "./component/Modal/SubmitAfterModal";
import Rejects2 from "./component/Dashboard/UserDashboard/Service/RoadTransport/accpentAndReject/Rejects2";
import Approve2 from "./component/Dashboard/UserDashboard/Service/RoadTransport/accpentAndReject/Approve2";
import PrivateRoute from "./component/privateRoute/PrivateRoute";
import ProductType from "./component/Dashboard/AdminDashboard/Pages/AddProduct/AddProduct";
import AddEquipment from "./component/Dashboard/AdminDashboard/Pages/AddEquipment/AddEquipment";
import AddVehicleType from "./component/Dashboard/AdminDashboard/Pages/AddVehicleType/AddVehicleType";
import useFetch from "./hooks/useFetch";
import Article from "./component/Dashboard/AdminDashboard/Pages/Article/Article";
import AddArticle from "./component/Dashboard/AdminDashboard/Pages/Article/AddArticle";
import RequestQuoteAfter from "./component/Pages/RequestQuote/RequestQuoteAfter";
import RequestQuote from "./component/Pages/RequestQuote/RequestQuote";
import ProductDetails from "./component/Pages/RequestQuote/ProdectDetails";
import AdminHomeDashboard from "./component/Dashboard/AdminDashboard/AdminHomeDashboard/AdminHomeDashboard";
import PrivateRouteAdmin from "./component/privateRoute/PrivateRouteAdmin";
import AdminLoginModal from "./component/Modal/AdminLoginModal";
import EditArticle from "./component/Dashboard/AdminDashboard/Pages/Article/EditArticle";
import RequestQuoteEdit from "./component/Pages/RequestQuoteEdit/RequestQuote";
import ArticleDetails from "./component/Pages/ArticleDetails/ArticleDetails";

function App() {
  const [shaw, setIsShaw] = useState(true);
  const [isShaws, setIsShaws] = useState(true);
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const [loginModalOpen, setLoginModalOpen] = useState(false);
  const [adminLoginModal, setAdminLoginModal] = useState(false);
  const [afterSubmitModalOpen, setAfterSubmitModalOpen] = useState(false);
  console.log(loginModalOpen);
  const { data: equipmentsData, loading: equipmentLoading } = useFetch(
    "https://abc-backend.onrender.com/api/equipments"
  );
  const { data: productData } = useFetch(
    "https://abc-backend.onrender.com/api/products"
  );
  const { data: vehicleData } = useFetch(
    "https://abc-backend.onrender.com/api/vehicles"
  );
  const { data: articleData } = useFetch(
    "https://abc-backend.onrender.com/api/articles"
  );
  return (
    <div>
      <Router>
        {/* <Navbar isShaw={isShaw} setIsShaw={setIsShaw} /> */}
        {modalOpen && (
          <Modal
            setModalOpen={setModalOpen}
            setAfterSubmitModalOpen={setAfterSubmitModalOpen}
          />
        )}
        {loginModalOpen && (
          <LoginModal
            setLoginModalOpen={setLoginModalOpen}
            setAfterSubmitModalOpen={setAfterSubmitModalOpen}
            setModalOpen={setModalOpen}
          />
        )}
        {adminLoginModal && (
          <AdminLoginModal setAdminLoginModal={setAdminLoginModal} />
        )}
        {afterSubmitModalOpen && (
          <SubmitAfterModal setAfterSubmitModalOpen={setAfterSubmitModalOpen} />
        )}

        <Routes>
          <Route
            path="/"
            element={
              <Home
                isShaw={shaw}
                setIsShaw={setIsShaw}
                modalOpen={modalOpen}
                setModalOpen={setModalOpen}
                setLoginModalOpen={setLoginModalOpen}
                equipmentsData={equipmentsData}
                equipmentLoading={equipmentLoading}
                productData={productData}
                vehicleData={vehicleData}
              />
            }
          />
          <Route
            path="/request1"
            element={<RequestQuoteAfter isShaw={shaw} setIsShaw={setIsShaw} />}
          />

          <Route
            path="/booking"
            element={
              <Booking
                isShaw={shaw}
                setIsShaw={setIsShaw}
                equipmentsData={equipmentsData}
                equipmentLoading={equipmentLoading}
                productData={productData}
                vehicleData={vehicleData}
              />
            }
          />

          <Route
            path="/prodect-details"
            element={
              <PrivateRoute setLoginModalOpen={setLoginModalOpen}>
                <ProductDetails isShaw={shaw} setIsShaw={setIsShaw} />
              </PrivateRoute>
            }
          />
          <Route
            path="/request-a-quote"
            element={
              <RequestQuote
                isShaw={shaw}
                setIsShaw={setIsShaw}
                modalOpen={modalOpen}
                setModalOpen={setModalOpen}
                setLoginModalOpen={setLoginModalOpen}
                equipmentsData={equipmentsData}
                equipmentLoading={equipmentLoading}
                productData={productData}
                vehicleData={vehicleData}
              />
            }
          />
          <Route
            path="/request-a-quote/:id"
            element={
              <PrivateRoute setLoginModalOpen={setLoginModalOpen}>
                <RequestQuoteEdit
                  isShaw={shaw}
                  setIsShaw={setIsShaw}
                  modalOpen={modalOpen}
                  setModalOpen={setModalOpen}
                  setLoginModalOpen={setLoginModalOpen}
                  equipmentsData={equipmentsData}
                  equipmentLoading={equipmentLoading}
                  productData={productData}
                  vehicleData={vehicleData}
                />
              </PrivateRoute>
            }
          />
          <Route
            path="/article-details/:id"
            element={
              <PrivateRoute setLoginModalOpen={setLoginModalOpen}>
                <ArticleDetails isShaw={shaw} setIsShaw={setIsShaw} />
              </PrivateRoute>
            }
          />
          {/* admindahsboard */}
          <Route
            path="/siteadmin"
            element={
              <PrivateRouteAdmin setAdminLoginModal={setAdminLoginModal}>
                <AdminHomeDashboard
                  sidebarOpen={sidebarOpen}
                  setSidebarOpen={setSidebarOpen}
                />
              </PrivateRouteAdmin>
            }
          >
            <Route
              path="/siteadmin/customer"
              element={
                <CustomerREQ
                  sidebarOpen={sidebarOpen}
                  setSidebarOpen={setSidebarOpen}
                />
              }
            ></Route>
            <Route
              path="/siteadmin"
              element={
                <Chart
                  sidebarOpen={sidebarOpen}
                  setSidebarOpen={setSidebarOpen}
                />
              }
            ></Route>
            <Route
              path="/siteadmin/req"
              element={
                <REQ
                  sidebarOpen={sidebarOpen}
                  setSidebarOpen={setSidebarOpen}
                />
              }
            ></Route>
            <Route
              path="/siteadmin/admin-quotes/:id"
              element={
                <AdminViewQuote
                  sidebarOpen={sidebarOpen}
                  setSidebarOpen={setSidebarOpen}
                />
              }
            ></Route>
            <Route
              path="/siteadmin/product-type"
              element={
                <ProductType
                  sidebarOpen={sidebarOpen}
                  setSidebarOpen={setSidebarOpen}
                />
              }
            ></Route>
            <Route
              path="/siteadmin/equipment-type"
              element={
                <AddEquipment
                  sidebarOpen={sidebarOpen}
                  setSidebarOpen={setSidebarOpen}
                />
              }
            ></Route>
            <Route
              path="/siteadmin/vehicle-type"
              element={
                <AddVehicleType
                  sidebarOpen={sidebarOpen}
                  setSidebarOpen={setSidebarOpen}
                />
              }
            ></Route>
            <Route
              path="/siteadmin/article"
              element={
                <Article
                  sidebarOpen={sidebarOpen}
                  setSidebarOpen={setSidebarOpen}
                  articleData={articleData}
                />
              }
            ></Route>
            <Route
              path="/siteadmin/add-article"
              element={
                <AddArticle
                  sidebarOpen={sidebarOpen}
                  setSidebarOpen={setSidebarOpen}
                  articleData={articleData}
                />
              }
            ></Route>
            <Route path="/siteadmin/:id" element={<EditArticle />}></Route>
          </Route>
          {/* userdashboard */}
          <Route
            path="/dashboard"
            element={
              <HomeDashboard isShaws={isShaws} setIsShaws={setIsShaws} />
            }
          >
            {/* user dash board component */}
            <Route
              path="/dashboard"
              element={<UserTab isShaws={isShaws} setIsShaw={setIsShaw} />}
            ></Route>
            <Route
              path="/dashboard/my-req"
              element={<UserTab isShaws={isShaws} setIsShaw={setIsShaw} />}
            ></Route>
            <Route
              path="/dashboard/req-for-change"
              element={<ReqForChange isShaws={isShaws} setIsShaw={setIsShaw} />}
            ></Route>
            <Route
              path="/dashboard/closed"
              element={<UserClosed isShaws={isShaws} setIsShaw={setIsShaw} />}
            ></Route>
            <Route
              path="/dashboard/quotes/:id"
              element={<ViewQuotes isShaws={isShaws} setIsShaw={setIsShaw} />}
            ></Route>
            <Route
              path="/dashboard/reject"
              element={<Rejects2 isShaws={isShaws} setIsShaw={setIsShaw} />}
            ></Route>
            <Route
              path="/dashboard/approve"
              element={<Approve2 isShaws={isShaws} setIsShaw={setIsShaw} />}
            ></Route>
          </Route>
        </Routes>
      </Router>
    </div>
  );
}

export default App;
